import React from "react";
import { GithubPicker } from "react-color";
import * as colors from "@material-ui/core/colors";

export default ({ input, ...rest }) => {
  // use all material colors that have shades
  const colorOrder = Object.keys(colors).filter(color =>
    Boolean(colors[color][500]),
  );
  const colorsObjects = colorOrder.map(color => colors[color]);
  const allColors = [].concat(
    ...colorsObjects.map(c => c[900]),
    ...colorsObjects.map(c => c[700]),
    ...colorsObjects.map(c => c[500]),
    ...colorsObjects.map(c => c[300]),
    ...colorsObjects.map(c => c[100]),
  );
  return (
    <GithubPicker
      triangle="hide"
      width={colorOrder.length * 25 + 12}
      colors={allColors}
      color={input ? input.value : undefined}
      onChange={({ hex }) => input && input.onChange(hex)}
      {...rest}
    />
  );
};
